import type { SVGProps } from "react";
import { memo } from "react";
const ManagedBlockchain = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m21.621 32.018-1.73-1.001A18.1 18.1 0 0 1 35.513 22c6.339 0 12.098 3.235 15.405 8.653l-1.707 1.042C46.27 26.877 41.149 24 35.513 24a16.1 16.1 0 0 0-13.892 8.018M49.199 48.25l1.731 1.001c-3.217 5.562-9.203 9.017-15.621 9.017-6.341 0-12.1-3.234-15.407-8.653l1.707-1.042c2.941 4.819 8.062 7.695 13.7 7.695a16.1 16.1 0 0 0 13.89-8.018m18.633-4.561-2 3-1.664-1.109.963-1.446H57v2a1 1 0 0 1-1 1H44a1 1 0 0 1-1-1v-3h-1v3a1 1 0 0 1-1 1H29a1 1 0 0 1-1-1v-3h-1v3a1 1 0 0 1-1 1H14a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4h1v-4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4h1v-4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2h4.131l-.963-1.445 1.664-1.109 2 3a1 1 0 0 1 0 1.109l-2 3-1.664-1.109.963-1.446H56a1 1 0 0 1-1-1v-2H45v4a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-4H30v4a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-4H15v10h10v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3h10v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3h10v-2a1 1 0 0 1 1-1h9.131l-.963-1.445 1.664-1.109 2 3a1 1 0 0 1 0 1.109M48 42.134h4v-4h-4zm-1-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-14 6h4v-4h-4zm-1-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-14 6h4v-4h-4zm-1-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1z"
      />
    </g>
  </svg>
);
const Memo = memo(ManagedBlockchain);
export default Memo;
